import Navbar from "../layout/Navbar";
import bgOne from "../assests/Images/our-teams-bg-one.jpg";
import bgTwo from "../assests/Images/modern-office-space-interior-min.jpg";
import { RiTeamFill } from "react-icons/ri";
import tmZero from "../assests/Images/ashok bal.jpg"
import tmOne from "../assests/Images/ArunMisra_image-PPT.png";
import tmTwo from "../assests/Images/SrinivasTanuku_Image-PPT.png";
import tmThree from "../assests/Images/Uday_Guha_image-PPT.png";
import tmFour from "../assests/Images/c-patnaik.png";
import tmFive from "../assests/Images/6 (1).png";
import tmSix from "../assests/Images/5.png";
import tmSeven from "../assests/Images/pramod-kumar-parida.png";
import { ImQuotesLeft } from "react-icons/im";
import Footer from "../layout/Footer";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { GiFlatStar } from "react-icons/gi";
import { useState } from "react";
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";

const OurTeam = () => {
  const { ref: ref3, inView: inView3 } = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);

  return (
    <>
      <Navbar />
      <div
        className="bg-cover bg-center h-screen lg:h-[80vh] md:h-[500px] sm:h-[400px] "
        style={{ backgroundImage: `url(${bgOne})` }}
      >
        <div className="h-full  bg-black bg-opacity-60 w-full flex flex-col justify-center items-center ">
          <h1 className="text-white text-4xl lg:text-6xl font-bold leading-tight">
            Meet Our Team
          </h1>
          <div className="h-1  mt-4 w-20 bg-white" />
          <p className="text-center xl:text-xl w-5/6 text-white">
            Our team comprises seasoned business consultants, productivity
            experts, and compliance specialists dedicated to driving sustainable
            growth for your organization. With deep expertise spanning human
            resources, operational excellence, and complex regulatory
            frameworks, we bring a wealth of practical, hands-on experience to
            every project. We pride ourselves on working collaboratively
            alongside your people—from the shop floor to the boardroom—ensuring
            that our strategic insights translate into measurable, real-world
            results.
          </p>
        </div>
      </div>

      <div className="w-full flex flex-col items-center justify-center text-center gap-3 xl:mt-16">
        <h1 className="text-4xl font-bold text-gray-900 leading-tight">
          Capitalizing on the{" "}
          <span className="text-primary">real-world experience</span>
        </h1>

        <p className="max-w-xl text-gray-600">
          Meet the exceptional individuals who drive our success through
          innovation, expertise, and dedication.
        </p>
      </div>

      <div className="px-4 py-10 h-fit">
        <div className="grid lg:grid-cols-3 mt-20 pb-6 gap-4 h-fit">
          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Ashok Kumar Bal"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmZero}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Ashok Kumar Bal
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Non-Executive Chairperson
              </p>
            </div>

            <p className="mt-4 text-center text-gray-900">
              A seasoned business leader and former Indian Revenue Service (IRS)
              officer, he has held leadership roles at Essel Mining & Industries
              Limited, Reliance Industries, and Mumbai Port Trust. With
              expertise in strategy, regulatory affairs, and infrastructure, he
              has also served on several high-level national committees.
            </p>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Arun K Misra"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmOne}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Arun K Misra
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Chief Executive
              </p>
            </div>

            <p className="mt-4 text-center text-gray-900">
              A seasoned business leader with 29 years of experience in Human
              Resources across manufacturing, telecom, IT, NBFC, KPO,
              infrastructure, and aviation. He specializes in operational
              excellence, talent management, and SAP-based HR transformation.
              Having led HR initiatives at leading organizations, he drives
              business growth through strategic, people-centric, and
              technology-enabled leadership.
            </p>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Arun K Misra"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmTwo}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Srinivas Tanuku
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Director-Productivity & Staffing
              </p>
            </div>

            <p className="mt-4 text-center text-gray-900">
              A competent Industrial Engineering professional with over 25 years
              of experience in the areas of Lean Management, Operational
              Excellence, Organization Effectiveness, Resource optimization,
              Process improvements.
            </p>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Uday Guha"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmThree}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Uday Guha
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">Director</p>
            </div>

            <p className="mt-4 text-center text-gray-900">
              A HR Leader of repute having 34 years of rich experience in
              various facets of HR having worked in Steel, Fertiliser,
              Automobile and Mining sectors.
            </p>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Lalitendu Samanta"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmFive}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Lalitendu Samanta
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Director- HR
              </p>
              <p className="mt-4 text-center text-gray-900">
                A seasoned HR professional with 30 years of experience in
                Strategic HR and HR Operations, he has driven organizational
                transformation across Tata Motors, Vedanta, Grasim, GMR, and
                Spark Minda Group. Expert in Organization Design, Talent
                Acquisition, Industrial Relations, and Change Management, with a
                strong record in Greenfield, M&A, and JV startups.
              </p>
            </div>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Gyanaranjan Sahu"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmSix}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Gyanaranjan Sahu
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">Director</p>
              <p className="mt-4 text-center text-gray-900">
                A seasoned techno-commercial leader with over 30 years of
                experience across IDCOL, ACC Cements, and the Adani Group. He
                has extensive expertise in commercial operations, stakeholder
                management, and large-scale logistics projects, with a strong
                track record of collaborating with government agencies, railway
                authorities , transport communities, and socio-political
                stakeholders.
              </p>
            </div>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="C Patnaik"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmFour}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                C Patnaik
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Technical Director
              </p>
            </div>

            <p className="mt-4 text-center text-gray-900">
              An agronomist from ISRO's Space Applications Centre, Mr. Patnaik
              served 33 years as Head of the Applications Techniques Development
              Division. A specialist in SAR data for vegetation monitoring and
              sensor design, he has contributed to GEOGLAM, GEOTrees, and
              NASA/JPL's NISAR mission. Recipient of the ISRO Team Award and the
              Green Asia Award.
            </p>
          </div>

          <div className="shadow-card p-4 rounded-md h-[400px] relative cursor-pointer transition-all duration-700 hover:scale-105 hover:bg-primary/10">
            <div className="flex flex-col items-center">
              <div className="relative p-1 rounded-full bg-gradient-to-r from-primary to-blue-300 group-hover:animate-pulse">
                <div className="bg-white rounded-full p-1">
                  <img
                    alt="Pramod Kumar Parida"
                    className="w-24 h-24 rounded-full object-cover"
                    src={tmSeven}
                  />
                </div>
                <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-primary rounded-full border-4 border-white flex items-center justify-center">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mt-4 text-center">
                Pramod Kumar Parida
              </h3>
              <p className="text-sm font-medium text-gray-600 mt-1">
                Technical Director
              </p>
              <p className="mt-4 text-center text-gray-900">
                A Senior Scientist from ORSAC with 35+ years of expertise in
                Remote Sensing, GIS, Photogrammetry, and Digital Image
                Processing. Holds an M.Sc. in Oceanography and a PG Diploma in
                RS & GIS from IIRS, ISRO. Superannuated in March 2024, he now
                serves as Director (Technical) at People Process Teck.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="text-center mb-12">
            <div
              className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 mb-4 text-red-600 border-red-200"
              data-v0-t="badge"
            >
              Our Methodology
            </div>
            <h1 className="text-4xl font-bold text-gray-900 leading-tight">
              Our Holistic <span className="text-primary">Approach </span>
            </h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              A comprehensive framework designed to transform organizations
              through strategic alignment and systematic implementation.
            </p>
          </div>
          <div className="space-y-4">
            <div className="rounded-lg border bg-white text-gray-800 shadow-md overflow-hidden transition-all duration-200 hover:shadow-lg">
              <div>
                {/* Header */}
                <div
                  className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setIsOpen1(!isOpen1)}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-8 h-8 rounded-full bg-red-50 border-red-200 border-2 flex items-center justify-center text-red-600 font-bold">
                      1
                    </div>
                    <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center text-red-600 text-lg">
                      🎯
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Define & Deploy
                      </h3>
                      <p className="text-sm text-gray-500">3 key focus areas</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold bg-gray-200 text-xs">
                      {isOpen1 ? "Collapse" : "Expand"}
                    </div>
                    <span className="text-xl">
                      {isOpen1 ? (
                        <MdOutlineKeyboardArrowDown />
                      ) : (
                        <MdOutlineKeyboardArrowRight />
                      )}
                    </span>
                  </div>
                </div>

                {/* Collapsible Content */}
                {isOpen1 && (
                  <div className="bg-red-50 border-t border-red-200">
                    <div className="p-6">
                      <h4 className="text-sm font-medium text-gray-700 mb-4 uppercase tracking-wide">
                        Key Focus Areas
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Vision, Mission, Values
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Customer-focused
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Business Strategy
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="rounded-lg border bg-white text-gray-800 shadow-md overflow-hidden transition-all duration-200 hover:shadow-lg">
              <div>
                {/* Header */}
                <div
                  className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setIsOpen2(!isOpen2)}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-8 h-8 rounded-full bg-blue-100 border-blue-200 border-2 flex items-center justify-center text-blue-600 font-bold">
                      2
                    </div>
                    <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 text-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-trending-up w-5 h-5 text-blue-600"
                      >
                        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                        <polyline points="16 7 22 7 22 13"></polyline>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Organization Effectiveness
                      </h3>
                      <p className="text-sm text-gray-500">3 key focus areas</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold bg-gray-200 text-xs">
                      {isOpen2 ? "Collapse" : "Expand"}
                    </div>
                    <span className="text-xl">
                      {isOpen2 ? (
                        <MdOutlineKeyboardArrowDown />
                      ) : (
                        <MdOutlineKeyboardArrowRight />
                      )}
                    </span>
                  </div>
                </div>

                {/* Collapsible Content */}
                {isOpen2 && (
                  <div className="bg-blue-50 border-t border-blue-200">
                    <div className="p-6">
                      <h4 className="text-sm font-medium text-gray-700 mb-4 uppercase tracking-wide">
                        Key Focus Areas
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Strategic goal alignment and functional integration.
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Agile and learning organization.
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Performance Management.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="rounded-lg border bg-white text-gray-800 shadow-md overflow-hidden transition-all duration-200 hover:shadow-lg">
              <div>
                {/* Header */}
                <div
                  className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setIsOpen3(!isOpen3)}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-8 h-8 rounded-full bg-red-50 border-red-200 border-2 flex items-center justify-center text-red-600 font-bold">
                      3
                    </div>
                    <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center text-red-600 text-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-zap w-5 h-5 text-green-600"
                      >
                        <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"></path>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Resource Optimization
                      </h3>
                      <p className="text-sm text-gray-500">4 key focus areas</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold bg-gray-200 text-xs">
                      {isOpen3 ? "Collapse" : "Expand"}
                    </div>
                    <span className="text-xl">
                      {isOpen3 ? (
                        <MdOutlineKeyboardArrowDown />
                      ) : (
                        <MdOutlineKeyboardArrowRight />
                      )}
                    </span>
                  </div>
                </div>

                {/* Collapsible Content */}
                {isOpen3 && (
                  <div className="bg-red-50 border-t border-red-200">
                    <div className="p-6">
                      <h4 className="text-sm font-medium text-gray-700 mb-4 uppercase tracking-wide">
                        Key Focus Areas
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Manpower Rationalization
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Productivity Improvement
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Cost reduction
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            HR Processes & Systems
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="rounded-lg border bg-white text-gray-800 shadow-md overflow-hidden transition-all duration-200 hover:shadow-lg">
              <div>
                {/* Header */}
                <div
                  className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setIsOpen4(!isOpen4)}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-8 h-8 rounded-full bg-blue-100 border-blue-200 border-2 flex items-center justify-center text-blue-600 font-bold">
                      4
                    </div>
                    <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600 text-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-users w-5 h-5 text-purple-600"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
                        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        HR Capability Improvement
                      </h3>
                      <p className="text-sm text-gray-500">5 key focus areas</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold bg-gray-200 text-xs">
                      {isOpen4 ? "Collapse" : "Expand"}
                    </div>
                    <span className="text-xl">
                      {isOpen4 ? (
                        <MdOutlineKeyboardArrowDown />
                      ) : (
                        <MdOutlineKeyboardArrowRight />
                      )}
                    </span>
                  </div>
                </div>

                {/* Collapsible Content */}
                {isOpen4 && (
                  <div className="bg-blue-50 border-t border-blue-200">
                    <div className="p-6">
                      <h4 className="text-sm font-medium text-gray-700 mb-4 uppercase tracking-wide">
                        Key Focus Areas
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Organization Structure, Role & KPIs
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Talent Management
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Leadership Development
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Future Talent/Leadership Pipeline
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Career & Succession Planning.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="rounded-lg border bg-white text-gray-800 shadow-md overflow-hidden transition-all duration-200 hover:shadow-lg">
              <div>
                {/* Header */}
                <div
                  className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={() => setIsOpen5(!isOpen5)}
                >
                  <div className="flex items-center space-x-4">
                    <div className="w-8 h-8 rounded-full bg-red-50 border-red-200 border-2 flex items-center justify-center text-red-600 font-bold">
                      5
                    </div>
                    <div className="w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center text-red-600 text-lg">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        className="lucide lucide-building2 w-5 h-5 text-orange-600"
                      >
                        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                        <path d="M10 6h4"></path>
                        <path d="M10 10h4"></path>
                        <path d="M10 14h4"></path>
                        <path d="M10 18h4"></path>
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900">
                        Institution Building
                      </h3>
                      <p className="text-sm text-gray-500">4 key focus areas</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold bg-gray-200 text-xs">
                      {isOpen5 ? "Collapse" : "Expand"}
                    </div>
                    <span className="text-xl">
                      {isOpen5 ? (
                        <MdOutlineKeyboardArrowDown />
                      ) : (
                        <MdOutlineKeyboardArrowRight />
                      )}
                    </span>
                  </div>
                </div>

                {/* Collapsible Content */}
                {isOpen5 && (
                  <div className="bg-red-50 border-t border-red-200">
                    <div className="p-6">
                      <h4 className="text-sm font-medium text-gray-700 mb-4 uppercase tracking-wide">
                        Key Focus Areas
                      </h4>
                      <ul className="space-y-3">
                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Cultural Transformation
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Corporate Governance
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            Change Management
                          </span>
                        </li>

                        <li className="flex items-start space-x-2">
                          <span className="mt-0.5 text-green-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-circle-check w-4 h-4 mt-0.5 text-red-600 flex-shrink-0"
                            >
                              <circle cx="12" cy="12" r="10"></circle>
                              <path d="m9 12 2 2 4-4"></path>
                            </svg>
                          </span>
                          <span className="text-gray-700 text-sm leading-relaxed">
                            IT enablement of system & process.
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OurTeam;
